import { ShovelIcon } from './ShovelIcon';

/**
 * author: Michael Richins
 * id 16D35D19-90C2-42DD-9E83-8F47E21A53DF
 * name shovel
 * version: 1.8.36
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/shovel.svg
 * tags
 * - Hardware / Tools 
 * - Agriculture 
 */
export const GardeningIcon = ShovelIcon;
export default GardeningIcon